document.documentElement.classList.add("js");

const root = document.documentElement;
const body = document.body;
const announcementBar = document.querySelector(".announcement-bar");
const siteHeader = document.querySelector(".site-header");

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-scroll-target]");

  if (!trigger) {
    return;
  }

  const selector = trigger.getAttribute("data-scroll-target");
  const target = selector ? document.querySelector(selector) : null;

  if (target) {
    target.scrollIntoView({ behavior: "auto", block: "start" });
  }
});

if (siteHeader) {
  let headerCondensed = siteHeader.classList.contains("is-condensed");
  let headerScrollFrame = 0;
  const headerCondenseAt = 90;
  const headerExpandAt = 16;

  const setHeaderCondensed = (shouldCondense) => {
    if (shouldCondense === headerCondensed) {
      return;
    }

    headerCondensed = shouldCondense;
    siteHeader.classList.toggle("is-condensed", shouldCondense);
    root.classList.toggle("is-site-header-condensed", shouldCondense);
  };

  const syncHeaderMeasurements = () => {
    if (announcementBar) {
      root.style.setProperty("--announcement-bar-height", `${announcementBar.offsetHeight}px`);
    }
  };

  const updateHeaderMeasurements = () => {
    const wasCondensed = headerCondensed;

    if (wasCondensed) {
      siteHeader.classList.remove("is-condensed");
    }

    root.style.setProperty("--site-header-height", `${siteHeader.offsetHeight}px`);
    syncHeaderMeasurements();

    if (wasCondensed) {
      siteHeader.classList.add("is-condensed");
    }
  };

  const updateHeaderState = () => {
    const currentScrollY = window.scrollY;
    const shouldCondense = headerCondensed ? currentScrollY > headerExpandAt : currentScrollY > headerCondenseAt;

    setHeaderCondensed(shouldCondense);
  };

  const scheduleHeaderStateUpdate = () => {
    if (headerScrollFrame) {
      return;
    }

    headerScrollFrame = window.requestAnimationFrame(() => {
      headerScrollFrame = 0;
      updateHeaderState();
    });
  };

  updateHeaderMeasurements();
  updateHeaderState();
  window.addEventListener("load", updateHeaderMeasurements);
  window.addEventListener("resize", () => {
    updateHeaderMeasurements();
    updateHeaderState();
  });
  window.addEventListener("scroll", scheduleHeaderStateUpdate, { passive: true });
}

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const centeredStickyPanels = Array.from(document.querySelectorAll(".shop-sidebar, .brands-sidebar, .brands-progress-sidebar"));

if (centeredStickyPanels.length) {
  let centeredStickyFrame = 0;

  const updateCenteredStickyPanels = () => {
    centeredStickyFrame = 0;
    const maxOffset = Math.max(0, (window.innerHeight / 2) - 16);

    centeredStickyPanels.forEach((panel) => {
      const centerOffset = Math.min(panel.offsetHeight / 2, maxOffset);
      panel.style.setProperty("--sticky-center-offset", `${centerOffset}px`);
    });
  };

  const scheduleCenteredStickyUpdate = () => {
    if (centeredStickyFrame) {
      return;
    }

    centeredStickyFrame = window.requestAnimationFrame(updateCenteredStickyPanels);
  };

  if ("ResizeObserver" in window) {
    const centeredStickyObserver = new ResizeObserver(scheduleCenteredStickyUpdate);
    centeredStickyPanels.forEach((panel) => centeredStickyObserver.observe(panel));
  }

  scheduleCenteredStickyUpdate();
  window.addEventListener("load", scheduleCenteredStickyUpdate);
  window.addEventListener("resize", scheduleCenteredStickyUpdate);
}

const supplierLogoMarquees = Array.from(document.querySelectorAll(".supplier-logo-marquee"));

if (supplierLogoMarquees.length && !prefersReducedMotion) {
  const setMarqueeSpeed = (track, rate) => {
    const animations = typeof track.getAnimations === "function" ? track.getAnimations() : [];

    if (!animations.length) {
      track.style.setProperty("--supplier-marquee-duration", rate < 1 ? "190s" : "82s");
      return;
    }

    animations.forEach((animation) => {
      if (typeof animation.updatePlaybackRate === "function") {
        animation.updatePlaybackRate(rate);
      } else {
        animation.playbackRate = rate;
      }
    });
  };

  supplierLogoMarquees.forEach((marquee) => {
    const track = marquee.querySelector(".supplier-logo-marquee__track");

    if (!track) {
      return;
    }

    marquee.addEventListener("pointerenter", () => setMarqueeSpeed(track, 0.22));
    marquee.addEventListener("pointerleave", () => setMarqueeSpeed(track, 1));
    marquee.addEventListener("focusin", () => setMarqueeSpeed(track, 0.22));
    marquee.addEventListener("focusout", () => {
      if (!marquee.contains(document.activeElement)) {
        setMarqueeSpeed(track, 1);
      }
    });
  });
}

const pressableLinkSelector = ".supply-list__link, .site-header__nav a, .button, .shop-filter, .shop-reset-brand, .shop-pagination__item, .shop-pagination__arrow, .brands-progress__link, .brand-card";

const clearPressedLinks = () => {
  document.querySelectorAll(`${pressableLinkSelector}.is-pressed`).forEach((link) => {
    link.classList.remove("is-pressed");
  });
};

document.addEventListener("pointerdown", (event) => {
  const link = event.target.closest(pressableLinkSelector);

  if (!link || event.button !== 0) {
    return;
  }

  link.classList.add("is-pressed");
});

document.addEventListener("pointerup", () => {
  window.setTimeout(clearPressedLinks, 140);
});

document.addEventListener("pointercancel", clearPressedLinks);

const catalogShop = document.querySelector("[data-catalog-shop]");

if (catalogShop && window.catalogData) {
  const data = window.catalogData;
  const details = window.catalogDetails || {};
  const searchInput = catalogShop.querySelector("[data-catalog-search]");
  const brandSelect = catalogShop.querySelector("[data-catalog-brand]");
  const brandResetButton = catalogShop.querySelector("[data-catalog-brand-reset]");
  const activeBrandLabel = catalogShop.querySelector("[data-catalog-active-brand]");
  const categoryButtons = Array.from(catalogShop.querySelectorAll("[data-catalog-category]"));
  const subcategoryButtons = Array.from(catalogShop.querySelectorAll("[data-catalog-subcategory]"));
  const subcategoryGroups = Array.from(catalogShop.querySelectorAll("[data-catalog-subcategory-group]"));
  const brandStrip = catalogShop.querySelector("[data-catalog-brand-strip]");
  const grid = catalogShop.querySelector("[data-catalog-grid]");
  const count = catalogShop.querySelector("[data-catalog-count]");
  const empty = catalogShop.querySelector("[data-catalog-empty]");
  const pagination = catalogShop.querySelector("[data-catalog-pagination]");
  const allBrands = Array.from(new Set([...(data.wheelBrands || []), ...(data.tyreBrands || [])])).sort((a, b) => a.localeCompare(b));
  const normaliseSearch = (value) => String(value).toLowerCase().replace(/[^a-z0-9]/g, "");
  const levenshteinDistance = (left, right, maxDistance = Number.POSITIVE_INFINITY) => {
    if (left === right) {
      return 0;
    }

    if (!left.length || !right.length) {
      return Math.max(left.length, right.length);
    }

    if (Math.abs(left.length - right.length) > maxDistance) {
      return maxDistance + 1;
    }

    let previous = Array.from({ length: right.length + 1 }, (_, index) => index);

    for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
      const current = [leftIndex];
      let bestInRow = current[0];

      for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
        const substitutionCost = left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1;
        const value = Math.min(
          previous[rightIndex] + 1,
          current[rightIndex - 1] + 1,
          previous[rightIndex - 1] + substitutionCost
        );

        current[rightIndex] = value;
        bestInRow = Math.min(bestInRow, value);
      }

      if (bestInRow > maxDistance) {
        return maxDistance + 1;
      }

      previous = current;
    }

    return previous[right.length];
  };

  const brandAliases = new Map([
    ["BF Goodrich", ["bfg", "bfgoodrich", "goodrich"]],
    ["GT Radial", ["gtradial", "gt"]],
    ["JRS Wheels", ["jrs", "jr", "jrwheels"]],
    ["KMC Wheels", ["kmc", "kmcwheels"]],
    ["CSA Wheels", ["csa", "csawheels"]],
    ["Icon Alloys", ["icon", "iconalloys"]],
    ["Level 8 Motorsports", ["level8", "level8motorsports"]],
    ["Mickey Thompson", ["mickey", "thompson", "mickeythompson"]],
    ["PDXX", ["pdx", "pdxx"]],
    ["R Series", ["rseries"]],
    ["Street Pro", ["streetpro", "street", "pro"]],
    ["US Mags", ["usmags", "usmag"]],
    ["XD Wheels", ["xd", "xdwheels"]]
  ]);

  const brandMatchScore = (brand, query) => {
    const normalisedQuery = normaliseSearch(query);

    if (!normalisedQuery) {
      return 100;
    }

    const normalisedBrand = normaliseSearch(brand);
    const aliases = brandAliases.get(brand) || [];
    const brandTokens = String(brand).split(/[^a-zA-Z0-9]+/).map(normaliseSearch).filter((token) => token.length >= 2);
    const candidates = [
      normalisedBrand,
      ...aliases.map(normaliseSearch),
      ...brandTokens
    ];

    if (candidates.some((candidate) => candidate === normalisedQuery)) {
      return 100;
    }

    if (candidates.some((candidate) => candidate.includes(normalisedQuery) || normalisedQuery.includes(candidate))) {
      return 88 - Math.min(normalisedQuery.length, 18);
    }

    const fuzzyCandidates = [
      normalisedBrand,
      ...aliases.map(normaliseSearch),
      ...brandTokens.filter((token) => token.length >= 4 && normalisedQuery.length >= 4 && Math.abs(token.length - normalisedQuery.length) <= 2)
    ].filter((candidate, index, list) => candidate && list.indexOf(candidate) === index);
    const scores = fuzzyCandidates.map((candidate) => {
      const allowedDistance = Math.max(1, Math.ceil(Math.min(candidate.length, normalisedQuery.length) * 0.32));
      const lengthPenalty = Math.abs(candidate.length - normalisedQuery.length);
      const distance = levenshteinDistance(candidate, normalisedQuery, allowedDistance);

      return distance <= allowedDistance ? 70 - distance - lengthPenalty : -1;
    });
    const bestScore = Math.max(...scores, -1);

    return bestScore >= 58 ? bestScore : -1;
  };

  const productSearchMatches = (product, query, normalisedQuery) => {
    if (!query) {
      return true;
    }

    if (product.searchText.includes(query) || product.normalisedSearchText.includes(normalisedQuery)) {
      return true;
    }

    const terms = [product.brand, product.model, product.category]
      .flatMap((value) => String(value).split(/[^a-zA-Z0-9]+/))
      .map(normaliseSearch)
      .filter((term) => term.length >= 4);

    return terms.some((term) => {
      if (Math.abs(term.length - normalisedQuery.length) > 2) {
        return false;
      }

      const allowedDistance = Math.max(1, Math.ceil(Math.min(term.length, normalisedQuery.length) * 0.28));
      return levenshteinDistance(term, normalisedQuery, allowedDistance) <= allowedDistance;
    });
  };

  const fourByFourWheelBrands = new Set([
    "PDXX",
    "Dirty Life",
    "R Series",
    "KMC Wheels",
    "Mayhem",
    "Level 8 Motorsports",
    "Icon Alloys",
    "Raceline Wheels",
    "Rubicon",
    "Mickey Thompson",
    "Moto Metal",
    "Pro Comp",
    "Dynamic Wheel Co",
    "Ion Wheels",
    "XD Wheels"
  ]);
  const passengerWheelBrands = new Set([
    "Advanti Racing",
    "American Racing",
    "Asanti Wheels",
    "Enkei",
    "GT Form",
    "JRS Wheels",
    "Lenso",
    "Motegi",
    "Orbit",
    "Petrol",
    "Reproduction Wheels",
    "Rotiform",
    "Street Pro",
    "TSW",
    "US Mags",
    "Kensei",
    "Konig",
    "Globe"
  ]);
  const fourByFourWheelPattern = /4x4|4wd|offroad|off-road|beadlock|bead lock|mud|trail|crawler|krawler|rubicon|patrol|landcruiser|land cruiser|ranger|raptor|hilux|gladiator|wrangler|bronco|baja|assault|havoc|dakar|raid|blak trak|hammer|outlaw|renegade|ridgeline|maverick|monster|predator|commando|militant|jackal|tracker|outback|desert|sunraysia|steel|dynamic|rebound|recon|raider|journey|compression|cajon|anza|alpha|bandit|warrior|scout|tank|grenade|rockstar|hoss|panzer|pike|reactor|thump|bomber|colossus|onslaught|rover|gauntlet|beacon|basecamp|roughneck|stryker|grid|snare|patriot|bandido/i;
  const passengerWheelPattern = /street|racing|race|sport|touring|drift|classic|muscle|forged|convo|monaco|bathurst|sprint|rally|dragway|daytona|eliminator|interceptor|challenger|cruiser|rpf|advan|storm|hypergram|dekagram|countergram|ultraform|reasons|torch|wideopen|rotiform|tsw|mags|magnum|verona|denaro|vigoroso|hybris|alonso|predator 5/i;
  const wheelUseFor = (product) => {
    if (product.category !== "Wheels") {
      return "";
    }

    const searchable = `${product.brand} ${product.model}`;
    const modelSearch = product.model;

    if (/^et drag$/i.test(modelSearch) || /drag/i.test(modelSearch)) {
      return "Passenger";
    }

    if (fourByFourWheelPattern.test(modelSearch)) {
      return "4x4";
    }

    if (fourByFourWheelBrands.has(product.brand)) {
      return "4x4";
    }

    if (passengerWheelPattern.test(searchable)) {
      return "Passenger";
    }

    if (passengerWheelBrands.has(product.brand)) {
      return "Passenger";
    }

    return "Passenger";
  };
  const fourByFourTyrePattern = /4x4|4wd|a\/t|at2|at3|at4|all.?terrain|m\/t|mud|mud.?terrain|rugged|trail|open country|geolandar|wildpeak|dueler|scorpion|road venture|grabber|renegade|baja|dynapro|roadian|adventuro|s\/t|maxx|x-?at|r\/t|h\/t|suv|ltx|light.?truck|courser|klever|savero|discoverer|stronghold|stt|razr|bighorn|agilex/i;
  const passengerTyrePattern = /passenger|pilot|primacy|potenza|turanza|ecopia|p zero|cinturato|powergy|dragon|sportcontact|premiumcontact|ecocontact|comfortcontact|maxcontact|advan|bluearth|proxes|nanoenergy|ventus|kinergy|optimo|ecsta|solus|sense|sportactive|champiro|dimax|rivera|rpx|n'?fera|n'?blue|n'?priz|advantage|g-force|radial|stratus|avenger|evolution|zeon|premitra|victra|mecotra|komet|kenetica|vezda/i;
  const tyreUseFor = (product) => {
    if (product.category !== "Tyres") {
      return "";
    }

    const searchable = `${product.brand} ${product.model}`;

    if (fourByFourTyrePattern.test(searchable)) {
      return "4x4";
    }

    if (passengerTyrePattern.test(searchable)) {
      return "Passenger";
    }

    return "Passenger";
  };

  const pageSize = 16;
  const detailKeyFor = (category, brand, model) => `${category}::${brand}::${model}`;
  const assetScript = document.querySelector('script[src*="theme.js"]');
  const assetBaseUrl = assetScript ? assetScript.src.split("/theme.js")[0] : "";
  const localAssetUrlFor = (filename) => {
    return filename && assetBaseUrl ? `${assetBaseUrl}/${filename}` : "";
  };
  const seededProducts = (data.groups || []).flatMap((group) => {
    return (group.models || []).map((model, index) => ({
      brand: group.brand,
      category: group.category,
      model,
      detailKey: detailKeyFor(group.category, group.brand, model),
      id: normaliseSearch(`${group.category}-${group.brand}-${model}-${index}`),
      localImage: group.localImages?.[model] || "",
      image: group.images?.[model] || "",
      description: group.descriptions?.[model] || "",
      availableSizes: group.availableSizes?.[model] || [],
      productUrl: group.productUrls?.[model] || group.sourceUrl || "",
      sourceUrl: group.sourceUrl || "",
      searchText: `${group.category} ${group.brand} ${model}`.toLowerCase(),
      normalisedSearchText: normaliseSearch(`${group.category} ${group.brand} ${model}`)
    }));
  });
  const seededBrandCategories = new Set(seededProducts.map((product) => `${product.category}:${product.brand}`));
  const brandRangeProducts = [
    ...(data.tyreBrands || []).map((brand) => ({ brand, category: "Tyres" })),
    ...(data.wheelBrands || []).map((brand) => ({ brand, category: "Wheels" }))
  ].filter((item) => !seededBrandCategories.has(`${item.category}:${item.brand}`)).map((item) => ({
    brand: item.brand,
    category: item.category,
    model: `${item.brand} range`,
    id: normaliseSearch(`${item.category}-${item.brand}-range`),
    image: "",
    description: "",
    availableSizes: [],
    productUrl: "",
    sourceUrl: "",
    isBrandRange: true,
    searchText: `${item.category} ${item.brand} ${item.brand} range available shop enquiry`.toLowerCase(),
    normalisedSearchText: normaliseSearch(`${item.category} ${item.brand} ${item.brand} range available shop enquiry`)
  }));
  const products = [...seededProducts, ...brandRangeProducts];
  products.forEach((product) => {
    const productDetails = details[product.detailKey] || {};
    product.image = productDetails.images?.[0] || productDetails.image || product.image;
    product.localImage = productDetails.localImage || product.localImage;
    product.images = productDetails.images || (product.image ? [product.image] : []);
    product.description = productDetails.description || product.description;
    product.availableSizes = productDetails.availableSizes || product.availableSizes;
    product.notes = productDetails.notes || [];
    product.productUrl = productDetails.productUrl || product.productUrl;
    product.wheelUse = wheelUseFor(product);
    product.tyreUse = tyreUseFor(product);

    if (product.wheelUse) {
      const wheelUseTerms = product.wheelUse === "4x4"
        ? "4x4 4wd offroad off-road all terrain wheel wheels"
        : "passenger street performance car wheel wheels";
      product.searchText = `${product.searchText} ${wheelUseTerms}`.toLowerCase();
      product.normalisedSearchText = normaliseSearch(product.searchText);
    }

    if (product.tyreUse) {
      const tyreUseTerms = product.tyreUse === "4x4"
        ? "4x4 4wd offroad off-road all terrain tyre tire tyres tires"
        : "passenger street performance car tyre tire tyres tires";
      product.searchText = `${product.searchText} ${tyreUseTerms}`.toLowerCase();
      product.normalisedSearchText = normaliseSearch(product.searchText);
    }
  });
  let activeCategory = "All";
  let activeSubcategory = "";
  let currentPage = 1;

  const escapeHtml = (value) => {
    return String(value).replace(/[&<>"']/g, (character) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&#39;"
      }[character];
    });
  };

  const decodeHtml = (value) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = String(value || "");
    return textarea.value;
  };

  const cleanProductText = (value) => {
    const decoded = decodeHtml(value)
      .replace(/\[et_pb[\s\S]*$/i, "")
      .replace(/\[\/?et_[^\]]+\]/gi, " ")
      .replace(/\b(?:_builder_version|sale_badge|custom_padding|background_(?:size|position|repeat)|admin_label)=\S+/gi, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!decoded || decoded.length < 32 || decoded.match(/et_pb|_builder_version|sale_badge_text_color/i)) {
      return "";
    }

    if (decoded.match(/Select your store|Passenger Tires Passenger|TRUCK\/SUV\/CUV|Commercial Truck Tires|Off-the-Road Tires|Tire Line-up|Tyre Line-up|Vehicle Gallery|Home Posts Gallery|Gallery Understanding Fitment|HOME Wheels Dealers Visualizer|Previous Page STYLE|Size Code|P\.R\.|LI\/SR|T\.D\.|O\.D\.|S\.W\.|R\.W\.|LCC@AP|32nds|\b\d{3}\/\d{2}R\d{2}\b|Triangle Tire is proud to have developed|available through 110 Garage|listed in the .* (?:catalog(?:ue)?|shop)|Contact the shop for current Australian availability/i)) {
      return "";
    }

    if (decoded.length <= 640) {
      return decoded;
    }

    const clipped = decoded.slice(0, 640);
    const sentenceEnd = Math.max(clipped.lastIndexOf(". "), clipped.lastIndexOf("! "), clipped.lastIndexOf("? "));
    return (sentenceEnd > 160 ? clipped.slice(0, sentenceEnd + 1) : clipped).trim();
  };

  const enquiryUrlFor = (product) => {
    const subject = encodeURIComponent(`${product.brand} ${product.model}`);
    const brand = encodeURIComponent(product.brand);
    const category = encodeURIComponent(product.category);
    return `/pages/contact?product=${subject}&brand=${brand}&category=${category}`;
  };

  const inlineContactLinkFor = (product, label = "Contact us") => {
    return `<a class="inline-fill-link" href="${escapeHtml(enquiryUrlFor(product))}">${escapeHtml(label)}</a>`;
  };

  const isDefaultDescription = (value) => {
    return String(value || "").match(/^contact us for more information regarding this product!?$/i);
  };

  const defaultDescriptionMarkupFor = (product) => {
    return `${inlineContactLinkFor(product, "Contact us")} for more information regarding this product!`;
  };

  const descriptionMarkupFor = (product) => {
    const cleanDescription = cleanProductText(product.description);

    if (cleanDescription && !isDefaultDescription(cleanDescription)) {
      return escapeHtml(cleanDescription);
    }

    return defaultDescriptionMarkupFor(product);
  };

  const fitmentMarkupFor = (product) => {
    return `<li>Get in ${inlineContactLinkFor(product, "contact")} with us to learn if this fits your vehicle!</li>`;
  };

  const imageFor = (product) => {
    return localAssetUrlFor(product.localImage) || product.image || "";
  };

  const placeholderImageFor = (product) => {
    return localAssetUrlFor(product.category === "Tyres" ? "catalog-placeholder-tyre.png" : "catalog-placeholder-wheel.png");
  };

  const categoryClassFor = (product) => {
    return normaliseSearch(product.category || "wheels") || "wheels";
  };

  const filterLabelFor = (category, subcategory = activeSubcategory) => {
    if (category === "Vehicle4x4") {
      return "4x4 Wheels & Tyres";
    }

    if (category === "VehiclePassenger") {
      return "Passenger Wheels & Tyres";
    }

    if (category === "AccessoriesSpecialties") {
      return "Accessories / Specialties";
    }

    if ((category === "Wheels" || category === "Tyres") && subcategory) {
      return `${category} / ${subcategory}`;
    }

    return category;
  };

  const matchesCategoryFilter = (product, category = activeCategory, subcategory = activeSubcategory) => {
    if (category === "All") {
      return true;
    }

    if (category === "Vehicle4x4") {
      return (product.category === "Wheels" && product.wheelUse === "4x4") || (product.category === "Tyres" && product.tyreUse === "4x4");
    }

    if (category === "VehiclePassenger") {
      return (product.category === "Wheels" && product.wheelUse === "Passenger") || (product.category === "Tyres" && product.tyreUse === "Passenger");
    }

    if (category === "AccessoriesSpecialties") {
      return product.category === "Accessories" || product.category === "Specialties";
    }

    if (category === "Wheels") {
      return product.category === "Wheels" && (!subcategory || product.wheelUse === subcategory);
    }

    if (category === "Tyres") {
      return product.category === "Tyres" && (!subcategory || product.tyreUse === subcategory);
    }

    return product.category === category && !subcategory;
  };

  const brandsForCategory = (category = activeCategory) => {
    return Array.from(new Set(
      products
        .filter((product) => matchesCategoryFilter(product, category))
        .map((product) => product.brand)
    )).sort((a, b) => a.localeCompare(b));
  };

  const allBrandLabelFor = (category = activeCategory, subcategory = activeSubcategory) => {
    if (category === "Tyres") {
      return subcategory ? `All ${subcategory} Tyre Brands` : "All Tyre Brands";
    }

    if (category === "Wheels") {
      return subcategory ? `All ${subcategory} Wheel Brands` : "All Wheel Brands";
    }

    if (category === "Vehicle4x4") {
      return "All 4x4 Brands";
    }

    if (category === "VehiclePassenger") {
      return "All Passenger Brands";
    }

    if (category === "AccessoriesSpecialties") {
      return "All Accessory & Specialty Brands";
    }

    if (category === "Specialties") {
      return "All Specialty Brands";
    }

    if (category === "Accessories") {
      return "All Accessory Brands";
    }

    return "All Brands";
  };

  const populateBrandOptions = ({ preserveSelection = true } = {}) => {
    if (!brandSelect) {
      return "All";
    }

    const currentBrand = preserveSelection ? brandSelect.value : "All";
    const availableBrands = brandsForCategory();
    brandSelect.innerHTML = "";
    const allOption = document.createElement("option");
    allOption.value = "All";
    allOption.textContent = allBrandLabelFor();
    brandSelect.appendChild(allOption);

    availableBrands.forEach((brand) => {
      const option = document.createElement("option");
      option.value = brand;
      option.textContent = brand;
      brandSelect.appendChild(option);
    });

    brandSelect.value = availableBrands.includes(currentBrand) ? currentBrand : "All";
    return brandSelect.value;
  };

  const updateFilterControls = () => {
    categoryButtons.forEach((button) => {
      const isActive = (button.dataset.catalogCategory || "All") === activeCategory;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    subcategoryGroups.forEach((group) => {
      const isHidden = group.dataset.catalogSubcategoryGroup !== activeCategory;
      group.hidden = isHidden;
      group.setAttribute("aria-hidden", isHidden ? "true" : "false");
    });

    subcategoryButtons.forEach((button) => {
      const parentCategory = button.dataset.catalogParentCategory || "";
      const subcategory = button.dataset.catalogSubcategory || "";
      const isActive = parentCategory === activeCategory && subcategory === activeSubcategory;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  if (brandStrip) {
    brandStrip.innerHTML = allBrands.map((brand) => `<span>${escapeHtml(brand)}</span>`).join("");
  }

  const urlParams = new URLSearchParams(window.location.search);
  const bestBrandMatchFor = (value, candidateBrands = allBrands) => {
    const query = String(value || "").trim();

    if (!query) {
      return "";
    }

    const exactMatch = candidateBrands.find((brand) => normaliseSearch(brand) === normaliseSearch(query));

    if (exactMatch) {
      return exactMatch;
    }

    const bestMatch = candidateBrands
      .map((brand) => ({ brand, score: brandMatchScore(brand, query) }))
      .sort((left, right) => right.score - left.score)[0];

    return bestMatch?.score >= 58 ? bestMatch.brand : "";
  };

  const filterStateFromValue = (value) => {
    const normalisedValue = normaliseSearch(value);
    const legacyMap = {
      "4x4": { category: "Vehicle4x4", subcategory: "" },
      "4wd": { category: "Vehicle4x4", subcategory: "" },
      "4x4wheelsandtyres": { category: "Vehicle4x4", subcategory: "" },
      "4x4wheelsandtires": { category: "Vehicle4x4", subcategory: "" },
      "4x4wheels": { category: "Wheels", subcategory: "4x4" },
      "passengerwheels": { category: "Wheels", subcategory: "Passenger" },
      "passenger": { category: "VehiclePassenger", subcategory: "" },
      "passengerwheelsandtyres": { category: "VehiclePassenger", subcategory: "" },
      "passengerwheelsandtires": { category: "VehiclePassenger", subcategory: "" },
      "accessoriesspecialties": { category: "AccessoriesSpecialties", subcategory: "" },
      "accessoriesandspecialties": { category: "AccessoriesSpecialties", subcategory: "" },
      "4x4tyres": { category: "Tyres", subcategory: "4x4" },
      "4x4tires": { category: "Tyres", subcategory: "4x4" },
      "passengertyres": { category: "Tyres", subcategory: "Passenger" },
      "passengertires": { category: "Tyres", subcategory: "Passenger" }
    };

    if (legacyMap[normalisedValue]) {
      return legacyMap[normalisedValue];
    }

    const matchedButton = categoryButtons.find((button) => normaliseSearch(button.dataset.catalogCategory) === normalisedValue);

    if (matchedButton) {
      return {
        category: matchedButton.dataset.catalogCategory || "All",
        subcategory: ""
      };
    }

    return null;
  };

  const applyInitialFiltersFromUrl = () => {
    const brandParam = urlParams.get("brand") || urlParams.get("catalogBrand");
    const categoryParam = urlParams.get("category");
    const searchParam = urlParams.get("q") || urlParams.get("search");

    if (categoryParam) {
      const matchedState = filterStateFromValue(categoryParam);

      if (matchedState) {
        activeCategory = matchedState.category;
        activeSubcategory = matchedState.subcategory;
        updateFilterControls();
      }
    }

    populateBrandOptions({ preserveSelection: false });

    if (brandSelect && brandParam) {
      const matchedBrand = bestBrandMatchFor(brandParam, brandsForCategory());

      if (matchedBrand) {
        brandSelect.value = matchedBrand;
      }
    }

    if (searchInput && searchParam) {
      searchInput.value = searchParam.slice(0, 80);
    }
  };

  const getPageItems = (current, total) => {
    if (total <= 5) {
      return Array.from({ length: total }, (_, index) => index + 1);
    }

    if (current <= 3) {
      return [1, 2, 3, 4, 5];
    }

    if (current >= total - 2) {
      return [total - 4, total - 3, total - 2, total - 1, total];
    }

    return [current - 2, current - 1, current, current + 1, current + 2];
  };

  const scrollShopResultsToTop = () => {
    const target = catalogShop.querySelector(".shop-grid-heading") || catalogShop;
    const headerOffset = (announcementBar?.offsetHeight || 0) + (siteHeader?.offsetHeight || 0) + 16;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion ? "auto" : "smooth"
    });
  };

  const renderPagination = (totalPages) => {
    if (!pagination) {
      return;
    }

    if (totalPages <= 1) {
      pagination.hidden = true;
      pagination.innerHTML = "";
      return;
    }

    const pages = getPageItems(currentPage, totalPages);
    const pageButtons = pages.map((page) => {
      const distance = Math.abs(page - currentPage);
      const fadeClass = distance >= 2 ? "shop-pagination__item--far" : distance === 1 ? "shop-pagination__item--near" : "";
      const activeClass = page === currentPage ? " is-active" : "";
      return `<button class="shop-pagination__item ${fadeClass}${activeClass}" type="button" data-catalog-page="${page}" aria-label="Go to page ${page}" ${page === currentPage ? 'aria-current="page"' : ""}>${page}</button>`;
    }).join("");

    pagination.hidden = false;
    pagination.innerHTML = `
      <button class="shop-pagination__arrow" type="button" data-catalog-page-prev aria-label="Previous page" ${currentPage === 1 ? "disabled" : ""}>&lt;</button>
      ${pageButtons}
      <button class="shop-pagination__arrow" type="button" data-catalog-page-next aria-label="Next page" ${currentPage === totalPages ? "disabled" : ""}>&gt;</button>
    `;
  };

  const render = ({ resetPage = false } = {}) => {
    const query = (searchInput?.value || "").trim().toLowerCase();
    const normalisedQuery = normaliseSearch(query);
    const selectedBrand = brandSelect?.value || "All";
    const filteredProducts = products.filter((product) => {
      const matchesCategory = matchesCategoryFilter(product);
      const matchesBrand = selectedBrand === "All" || product.brand === selectedBrand;
      const matchesSearch = productSearchMatches(product, query, normalisedQuery);

      return matchesCategory && matchesBrand && matchesSearch;
    });
    const totalPages = Math.max(1, Math.ceil(filteredProducts.length / pageSize));

    if (resetPage) {
      currentPage = 1;
    }

    currentPage = Math.min(Math.max(currentPage, 1), totalPages);
    const pageStart = (currentPage - 1) * pageSize;
    const visibleProducts = filteredProducts.slice(pageStart, pageStart + pageSize);

    if (count) {
      const visibleStart = filteredProducts.length ? pageStart + 1 : 0;
      const visibleEnd = Math.min(pageStart + visibleProducts.length, filteredProducts.length);
      count.textContent = `${visibleStart}-${visibleEnd} of ${filteredProducts.length} results`;
    }

    if (activeBrandLabel) {
      const activeFilters = [
        ...(activeCategory !== "All" ? [filterLabelFor(activeCategory, activeSubcategory)] : []),
        ...(selectedBrand !== "All" ? [selectedBrand] : [])
      ];

      activeBrandLabel.hidden = false;
      activeBrandLabel.innerHTML = activeFilters.length
        ? `<span class="shop-active-brand__prefix">Searching for:</span> <span class="shop-active-brand__value">${escapeHtml(activeFilters.join(" / "))}</span>`
        : `<span class="shop-active-brand__prefix">Searching through:</span> <span class="shop-active-brand__value">all products</span>`;
    }

    if (brandResetButton) {
      brandResetButton.hidden = selectedBrand === "All";
    }

    if (empty) {
      empty.hidden = filteredProducts.length > 0;
    }

    if (!grid) {
      return;
    }

    grid.innerHTML = visibleProducts.map((product) => {
      const safeBrand = escapeHtml(product.brand);
      const safeModel = escapeHtml(product.model);
      const safeCategory = escapeHtml(product.category);
      const mediaImage = imageFor(product);
      const hasProductImage = Boolean(mediaImage);
      const placeholderImage = placeholderImageFor(product);
      const placeholderClass = categoryClassFor(product);
      const media = mediaImage
        ? `<img src="${escapeHtml(mediaImage)}" alt="${safeBrand} ${safeModel}" loading="lazy" decoding="async">`
        : `<img class="shop-card__placeholder shop-card__placeholder--${escapeHtml(placeholderClass)}" src="${escapeHtml(placeholderImage)}" alt="" loading="lazy" decoding="async">`;
      const metaText = product.isBrandRange
        ? `${safeBrand} products are available by enquiry. Contact 110 Garage with the model or setup you are chasing.`
        : `${safeCategory} model. Contact 110 Garage for sizing, pricing and fitment.`;

      return `
        <article class="shop-card ${hasProductImage ? "shop-card--has-image" : "shop-card--no-image"}" role="button" tabindex="0" data-catalog-product="${escapeHtml(product.id)}" aria-label="View ${safeBrand} ${safeModel}" aria-haspopup="dialog" aria-controls="ProductModal">
          <div class="shop-card__media" aria-hidden="true">
            ${media}
          </div>
          <div class="shop-card__body">
            <p class="shop-card__brand">${safeBrand}</p>
            <h2 class="shop-card__title">${safeModel}</h2>
            <p class="shop-card__meta">${metaText}</p>
            <div class="shop-card__actions">
              <a class="button" href="${enquiryUrlFor(product)}">Enquire</a>
            </div>
          </div>
        </article>
      `;
    }).join("");
    renderPagination(totalPages);
  };

  const modal = document.createElement("div");
  modal.className = "product-modal";
  modal.setAttribute("data-product-modal", "");
  modal.id = "ProductModal";
  modal.hidden = true;
  modal.innerHTML = `
    <button class="product-modal__backdrop" type="button" data-product-modal-close aria-label="Close product details" tabindex="-1"></button>
    <div class="product-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ProductModalTitle" aria-describedby="ProductModalDescription">
      <button class="product-modal__close" type="button" data-product-modal-close aria-label="Close product details">&times;</button>
      <div class="product-modal__media" data-product-modal-media></div>
      <div class="product-modal__content">
        <p class="product-modal__eyebrow" data-product-modal-brand></p>
        <h2 class="product-modal__title" id="ProductModalTitle" data-product-modal-title></h2>
        <p class="product-modal__description" id="ProductModalDescription" data-product-modal-description></p>
        <div class="product-modal__info">
          <div>
            <span>Category</span>
            <strong data-product-modal-category></strong>
          </div>
          <div>
            <span>Fitment</span>
            <ul data-product-modal-sizes></ul>
          </div>
          <div data-product-modal-notes-panel hidden>
            <span>Product notes</span>
            <ul data-product-modal-notes></ul>
          </div>
        </div>
        <div class="product-modal__actions">
          <a class="button" data-product-modal-enquire href="/pages/contact">Contact now</a>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const modalFocusableSelector = "a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex='-1'])";
  let modalReturnFocusTarget = null;

  const focusableModalElements = () => Array.from(modal.querySelectorAll(modalFocusableSelector))
    .filter((element) => element instanceof HTMLElement && !element.hidden && element.getClientRects().length);

  const focusWithoutScroll = (element) => {
    if (!element?.focus) {
      return;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  };

  const openProductModal = (product) => {
    const modalMedia = modal.querySelector("[data-product-modal-media]");
    const modalImage = imageFor(product);
    const modalPlaceholder = placeholderImageFor(product);
    const placeholderClass = categoryClassFor(product);
    const imageMarkup = modalImage
      ? `<img src="${escapeHtml(modalImage)}" alt="${escapeHtml(product.brand)} ${escapeHtml(product.model)}" decoding="async">`
      : `<img class="product-modal__placeholder product-modal__placeholder--${escapeHtml(placeholderClass)}" src="${escapeHtml(modalPlaceholder)}" alt="" decoding="async">`;

    modalMedia.innerHTML = imageMarkup;
    modalMedia.classList.toggle("product-modal__media--has-image", Boolean(modalImage));
    modalMedia.classList.toggle("product-modal__media--no-image", !modalImage);
    modal.querySelector("[data-product-modal-brand]").textContent = product.brand;
    modal.querySelector("[data-product-modal-title]").textContent = product.model;
    modal.querySelector("[data-product-modal-description]").innerHTML = descriptionMarkupFor(product);
    modal.querySelector("[data-product-modal-category]").textContent = product.category;
    modal.querySelector("[data-product-modal-sizes]").innerHTML = fitmentMarkupFor(product);
    const notesPanel = modal.querySelector("[data-product-modal-notes-panel]");
    const notesList = modal.querySelector("[data-product-modal-notes]");

    if (product.notes?.length) {
      notesPanel.hidden = false;
      notesList.innerHTML = product.notes.map((note) => `<li>${escapeHtml(note)}</li>`).join("");
    } else {
      notesPanel.hidden = true;
      notesList.innerHTML = "";
    }

    modal.querySelector("[data-product-modal-enquire]").href = enquiryUrlFor(product);
    modalReturnFocusTarget = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    modal.hidden = false;
    body.classList.add("has-modal-open");
    modal.querySelector(".product-modal__dialog")?.scrollTo({ top: 0, left: 0 });
    focusWithoutScroll(modal.querySelector(".product-modal__close"));
  };

  const closeProductModal = () => {
    modal.hidden = true;
    body.classList.remove("has-modal-open");
    modal.querySelector("[data-product-modal-media]").innerHTML = "";
    focusWithoutScroll(modalReturnFocusTarget);
    modalReturnFocusTarget = null;
  };

  modal.addEventListener("click", (event) => {
    if (event.target.closest("[data-product-modal-close]")) {
      closeProductModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (modal.hidden) {
      return;
    }

    if (event.key === "Escape") {
      closeProductModal();
      return;
    }

    if (event.key === "Tab") {
      const focusableElements = focusableModalElements();
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (!firstElement || !lastElement) {
        return;
      }

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  });

  grid?.addEventListener("click", (event) => {
    if (event.target.closest("a")) {
      return;
    }

    const card = event.target.closest("[data-catalog-product]");
    const product = products.find((item) => item.id === card?.dataset.catalogProduct);

    if (product) {
      openProductModal(product);
    }
  });

  grid?.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    const card = event.target.closest("[data-catalog-product]");
    const product = products.find((item) => item.id === card?.dataset.catalogProduct);

    if (product) {
      event.preventDefault();
      openProductModal(product);
    }
  });

  categoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      activeCategory = button.dataset.catalogCategory || "All";
      activeSubcategory = "";
      updateFilterControls();
      populateBrandOptions();
      render({ resetPage: true });
    });
  });

  subcategoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      activeCategory = button.dataset.catalogParentCategory || activeCategory;
      activeSubcategory = button.dataset.catalogSubcategory || "";
      updateFilterControls();
      populateBrandOptions();
      render({ resetPage: true });
    });
  });

  pagination?.addEventListener("click", (event) => {
    const pageButton = event.target.closest("[data-catalog-page]");
    const previousButton = event.target.closest("[data-catalog-page-prev]");
    const nextButton = event.target.closest("[data-catalog-page-next]");
    const previousPage = currentPage;

    if (pageButton) {
      currentPage = Number.parseInt(pageButton.dataset.catalogPage, 10) || 1;
      render();
    }

    if (previousButton) {
      currentPage -= 1;
      render();
    }

    if (nextButton) {
      currentPage += 1;
      render();
    }

    if (currentPage !== previousPage) {
      window.requestAnimationFrame(scrollShopResultsToTop);
    }
  });

  searchInput?.addEventListener("input", () => render({ resetPage: true }));
  brandSelect?.addEventListener("change", () => render({ resetPage: true }));
  brandResetButton?.addEventListener("click", () => {
    if (brandSelect) {
      brandSelect.value = "All";
    }

    render({ resetPage: true });
  });
  applyInitialFiltersFromUrl();
  updateFilterControls();
  render();
}

const brandsPage = document.querySelector("[data-brands-page]");

if (brandsPage && window.catalogData) {
  const data = window.catalogData;
  const shopUrl = brandsPage.dataset.shopUrl || "/collections/all";
  const searchForm = brandsPage.querySelector("[data-brand-search-form]");
  const searchInput = brandsPage.querySelector("[data-brand-search]");
  const alphaNav = brandsPage.querySelector("[data-brand-alpha]");
  const brandList = brandsPage.querySelector("[data-brand-list]");
  const brandCount = brandsPage.querySelector("[data-brand-count]");
  const emptyState = brandsPage.querySelector("[data-brand-empty]");
  const allAlphabetLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  let activeLetter = "";
  let brandScrollFrame = 0;

  const escapeBrandHtml = (value) => {
    return String(value).replace(/[&<>"']/g, (character) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&#39;"
      }[character];
    });
  };

  const normaliseBrandSearch = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const rawBrandLogoMap = (() => {
    const logoMapNode = brandsPage.querySelector("[data-brand-logo-map]");

    if (!logoMapNode) {
      return {};
    }

    try {
      return JSON.parse(logoMapNode.textContent || "{}");
    } catch (_error) {
      return {};
    }
  })();
  const brandLogoMap = new Map();
  Object.entries(rawBrandLogoMap).forEach(([name, logo]) => {
    brandLogoMap.set(name, logo);
    brandLogoMap.set(normaliseBrandSearch(name), logo);
  });
  const logoForBrand = (brand) => {
    return brandLogoMap.get(brand) || brandLogoMap.get(normaliseBrandSearch(brand));
  };
  const titleCaseCategory = (category) => category === "Tyres" ? "Tyres" : category === "Wheels" ? "Wheels" : category;
  const shopBrandUrlFor = (brand) => `${shopUrl}?brand=${encodeURIComponent(brand)}`;
  const firstLetterFor = (brand) => {
    const letter = String(brand || "").trim().charAt(0).toUpperCase();
    return letter.match(/[A-Z]/) ? letter : "#";
  };

  const brandMap = new Map();

  const ensureBrand = (brand) => {
    const cleanBrand = String(brand || "").trim();

    if (!cleanBrand) {
      return null;
    }

    if (!brandMap.has(cleanBrand)) {
      brandMap.set(cleanBrand, {
        name: cleanBrand,
        categories: new Set(),
        modelCount: 0,
        sourceCount: 0,
        search: normaliseBrandSearch(cleanBrand)
      });
    }

    return brandMap.get(cleanBrand);
  };

  (data.wheelBrands || []).forEach((brand) => {
    ensureBrand(brand)?.categories.add("Wheels");
  });

  (data.tyreBrands || []).forEach((brand) => {
    ensureBrand(brand)?.categories.add("Tyres");
  });

  (data.groups || []).forEach((group) => {
    const record = ensureBrand(group.brand);

    if (!record) {
      return;
    }

    if (group.category) {
      record.categories.add(titleCaseCategory(group.category));
    }

    record.modelCount += Array.isArray(group.models) ? group.models.length : 0;
    record.sourceCount += group.sourceUrl ? 1 : 0;
  });

  const brands = Array.from(brandMap.values()).sort((left, right) => left.name.localeCompare(right.name));

  const groupedBrandsFor = (visibleBrands) => {
    return visibleBrands.reduce((groups, brand) => {
      const letter = firstLetterFor(brand.name);

      if (!groups.has(letter)) {
        groups.set(letter, []);
      }

      groups.get(letter).push(brand);
      return groups;
    }, new Map());
  };

  const syncBrandProgressOffset = (activeLink) => {
    if (!alphaNav) {
      return;
    }

    const progressViewport = alphaNav.closest(".brands-progress-sidebar");

    if (!progressViewport || window.getComputedStyle(progressViewport).display === "none") {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      alphaNav.style.setProperty("--brands-progress-edge-pad", "0.18rem");
      return;
    }

    if (!activeLink) {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      alphaNav.style.setProperty("--brands-progress-edge-pad", "0.18rem");
      return;
    }

    const viewportHeight = progressViewport.clientHeight;

    if (!viewportHeight) {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      return;
    }

    const edgePadding = Math.max(0, (viewportHeight - activeLink.offsetHeight) / 2);
    alphaNav.style.setProperty("--brands-progress-edge-pad", `${edgePadding.toFixed(2)}px`);

    const trackHeight = alphaNav.scrollHeight;

    if (!trackHeight || trackHeight <= viewportHeight) {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      return;
    }

    const activeCenter = activeLink.offsetTop + (activeLink.offsetHeight / 2);
    const centeredShift = (viewportHeight / 2) - activeCenter;
    const minimumShift = viewportHeight - trackHeight;
    const clampedShift = Math.max(minimumShift, Math.min(0, centeredShift));
    alphaNav.style.setProperty("--brands-progress-shift", `${clampedShift.toFixed(2)}px`);
  };

  const setActiveLetter = (letter) => {
    activeLetter = letter || "";
    const activeIndex = allAlphabetLetters.indexOf(letter);
    let activeLink = null;

    alphaNav?.querySelectorAll("[data-brand-alpha-link]").forEach((link) => {
      const linkLetter = link.dataset.brandAlphaLink || "";
      const linkIndex = allAlphabetLetters.indexOf(linkLetter);
      const isActive = linkLetter === letter;
      const isPassed = activeIndex >= 0 && linkIndex >= 0 && linkIndex <= activeIndex;
      link.classList.toggle("is-active", isActive);
      link.classList.toggle("is-passed", isPassed);
      link.setAttribute("aria-current", isActive ? "true" : "false");

      if (isActive) {
        activeLink = link;
      }
    });

    window.requestAnimationFrame(() => syncBrandProgressOffset(activeLink));
  };

  const sectionForLetter = (letter) => {
    const sections = Array.from(brandList?.querySelectorAll("[data-brand-letter-section]") || []);
    const exactSection = sections.find((section) => section.dataset.brandLetterSection === letter);

    if (exactSection) {
      return exactSection;
    }

    const targetIndex = allAlphabetLetters.indexOf(letter);

    if (targetIndex < 0) {
      return null;
    }

    const nextSection = sections.find((section) => allAlphabetLetters.indexOf(section.dataset.brandLetterSection || "") > targetIndex);

    if (nextSection) {
      return nextSection;
    }

    for (let index = sections.length - 1; index >= 0; index -= 1) {
      const sectionIndex = allAlphabetLetters.indexOf(sections[index].dataset.brandLetterSection || "");

      if (sectionIndex < targetIndex) {
        return sections[index];
      }
    }

    return null;
  };

  const updateActiveLetterFromScroll = () => {
    brandScrollFrame = 0;

    const sections = Array.from(brandList?.querySelectorAll("[data-brand-letter-section]") || []);

    if (!sections.length) {
      return;
    }

    const progressPoint = window.innerHeight * 0.5;
    let current = sections[0];
    const scrollBottom = window.scrollY + window.innerHeight;
    const pageBottom = Math.max(
      document.body.scrollHeight,
      root.scrollHeight,
      document.body.offsetHeight,
      root.offsetHeight
    );

    sections.forEach((section) => {
      const top = section.getBoundingClientRect().top;

      if (top <= progressPoint) {
        current = section;
      }
    });

    if (pageBottom - scrollBottom <= 4) {
      current = sections[sections.length - 1];
    }

    setActiveLetter(current.dataset.brandLetterSection || "");
  };

  const scheduleActiveLetterUpdate = () => {
    if (brandScrollFrame) {
      return;
    }

    brandScrollFrame = window.requestAnimationFrame(updateActiveLetterFromScroll);
  };

  const renderBrands = () => {
    const query = normaliseBrandSearch(searchInput?.value || "");
    const visibleBrands = query
      ? brands.filter((brand) => brand.search.includes(query))
      : brands;
    const groupedBrands = groupedBrandsFor(visibleBrands);
    const letters = Array.from(groupedBrands.keys()).sort((left, right) => left.localeCompare(right));

    if (brandCount) {
      brandCount.textContent = visibleBrands.length === 1
        ? "1 brand"
        : `${visibleBrands.length} brands`;
    }

    if (emptyState) {
      emptyState.hidden = visibleBrands.length > 0;
    }

    if (alphaNav) {
      const availableLetters = new Set(letters);
      alphaNav.innerHTML = allAlphabetLetters.map((letter) => {
        const unavailableClass = availableLetters.has(letter) ? "" : " is-unavailable";
        const ariaLabel = availableLetters.has(letter)
          ? `Jump to ${letter} brands`
          : `Jump near ${letter} brands`;

        return `<a class="brands-progress__link${unavailableClass}" href="#BrandLetter-${escapeBrandHtml(letter)}" data-brand-alpha-link="${escapeBrandHtml(letter)}" aria-label="${escapeBrandHtml(ariaLabel)}"><span>${escapeBrandHtml(letter)}</span></a>`;
      }).join("");
    }

    if (brandList) {
      brandList.innerHTML = letters.map((letter) => {
        const cards = (groupedBrands.get(letter) || []).map((brand) => {
          const logo = logoForBrand(brand.name);
          const logoClass = logo?.tone === "light" ? " brand-card--light-logo" : "";
          const logoMarkup = logo?.src
            ? `<img src="${escapeBrandHtml(logo.src)}" alt="" loading="lazy" decoding="async" width="360" height="120">`
            : `<span class="brand-card__logo-fallback">${escapeBrandHtml(brand.name)}</span>`;

          return `
            <a class="brand-card${logoClass}" href="${escapeBrandHtml(shopBrandUrlFor(brand.name))}" aria-label="Shop ${escapeBrandHtml(brand.name)}">
              <span class="brand-card__logo" aria-hidden="true">${logoMarkup}</span>
              <span class="button brand-card__cta">Shop ${escapeBrandHtml(brand.name)}</span>
            </a>
          `;
        }).join("");

        return `
          <section class="brands-letter-section" id="BrandLetter-${escapeBrandHtml(letter)}" data-brand-letter-section="${escapeBrandHtml(letter)}">
            <h2>${escapeBrandHtml(letter)}</h2>
            <div class="brands-grid">${cards}</div>
          </section>
        `;
      }).join("");
    }

    setActiveLetter(letters[0] || "");
    window.requestAnimationFrame(updateActiveLetterFromScroll);
  };

  alphaNav?.addEventListener("click", (event) => {
    const link = event.target.closest("[data-brand-alpha-link]");

    if (!link) {
      return;
    }

    event.preventDefault();
    const target = sectionForLetter(link.dataset.brandAlphaLink || "");

    if (!target) {
      return;
    }

    const scrollOffset = Math.min(window.innerHeight * 0.32, 240);
    const top = target.getBoundingClientRect().top + window.scrollY - scrollOffset;
    window.scrollTo({ top, behavior: prefersReducedMotion ? "auto" : "smooth" });
    setActiveLetter(target.dataset.brandLetterSection || link.dataset.brandAlphaLink || "");
  });

  searchInput?.addEventListener("input", renderBrands);
  searchForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    brandList?.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
  });
  window.addEventListener("scroll", scheduleActiveLetterUpdate, { passive: true });
  window.addEventListener("resize", scheduleActiveLetterUpdate);
  renderBrands();
}

if (brandsPage && !window.catalogData) {
  brandsPage.querySelectorAll(".brands-letter-section").forEach((section) => {
    if (!section.querySelector(".brand-card")) {
      section.remove();
    }
  });
}

const contactMessage = document.querySelector("#ContactFormMessage");
const contactReference = document.querySelector("[data-contact-product-reference]");
const contactReferenceText = document.querySelector("[data-contact-product-reference-text]");
const contactReferenceRemove = document.querySelector("[data-contact-product-reference-remove]");
const contactReferenceProduct = document.querySelector("[data-contact-product-input]");
const contactReferenceBrand = document.querySelector("[data-contact-brand-input]");
const contactReferenceCategory = document.querySelector("[data-contact-category-input]");
const contactReferenceSource = document.querySelector("[data-contact-source-input]");

if (contactMessage) {
  const contactForm = contactMessage.closest("form");
  const contactSubmit = contactForm?.querySelector(".contact-form__submit");
  const contactHoneypots = Array.from(contactForm?.querySelectorAll("[data-contact-honeypot]") || []);
  const contactSpamStatus = contactForm?.querySelector("[data-contact-spam-status]");
  const requiredFields = Array.from(contactForm?.querySelectorAll("[data-contact-required]") || []);
  const contactMethodFields = Array.from(contactForm?.querySelectorAll("[data-contact-method]") || []);
  const contactMethodError = contactForm?.querySelector("[data-contact-method-error]");
  const contactStartedAt = Date.now();
  const minimumSubmitDelay = Math.max(0, Number.parseInt(contactForm?.dataset.contactMinSeconds || "0", 10) * 1000);
  const contactSubmitLabel = contactSubmit?.dataset.contactSubmitLabel || contactSubmit?.textContent?.trim() || "Submit";
  let contactCountdownTimer = 0;
  const contactParams = new URLSearchParams(window.location.search);
  const contactParam = (name, maxLength = 160) => (contactParams.get(name) || "").trim().slice(0, maxLength);
  const productQuery = contactParam("product", 140);
  const brandQuery = contactParam("brand", 80);
  const categoryQuery = contactParam("category", 40);
  const sourceQuery = contactParam("source", 420);

  if (productQuery && !contactMessage.value.trim()) {
    contactMessage.value = `Hi, I would like to enquire about ${productQuery}.\n\nMy vehicle is: `;
  }

  if (productQuery && contactReference) {
    const referenceLabel = [categoryQuery, productQuery].filter(Boolean).join(" - ");
    contactReference.hidden = false;
    contactReferenceText.textContent = referenceLabel;

    if (contactReferenceProduct) {
      contactReferenceProduct.value = productQuery;
    }

    if (contactReferenceBrand) {
      contactReferenceBrand.value = brandQuery;
    }

    if (contactReferenceCategory) {
      contactReferenceCategory.value = categoryQuery;
    }

    if (contactReferenceSource) {
      contactReferenceSource.value = sourceQuery;
    }
  }

  contactReferenceRemove?.addEventListener("click", () => {
    contactReference.hidden = true;
    [contactReferenceProduct, contactReferenceBrand, contactReferenceCategory, contactReferenceSource].forEach((input) => {
      if (input) {
        input.value = "";
      }
    });

    const cleanUrl = `${window.location.pathname}${window.location.hash || ""}`;
    window.history.replaceState({}, "", cleanUrl);
  });

  const setFieldInvalid = (field, isInvalid) => {
    const wrapper = field?.closest(".contact-form__field");

    if (!wrapper || !field) {
      return;
    }

    wrapper.classList.toggle("is-invalid", isInvalid);
    field.setAttribute("aria-invalid", isInvalid ? "true" : "false");
  };

  const setContactSpamStatus = (message, type = "warning") => {
    if (!contactSpamStatus) {
      return;
    }

    contactSpamStatus.hidden = !message;
    contactSpamStatus.textContent = message || "";
    contactSpamStatus.dataset.statusType = type;
  };

  const clearContactSpamStatus = () => setContactSpamStatus("");

  const remainingSubmitDelay = () => Math.max(0, minimumSubmitDelay - (Date.now() - contactStartedAt));

  const updateContactSubmitReadiness = () => {
    if (!contactSubmit || !minimumSubmitDelay) {
      return;
    }

    const remaining = remainingSubmitDelay();

    if (remaining > 0) {
      contactSubmit.disabled = true;
      contactSubmit.textContent = `Submit in ${Math.ceil(remaining / 1000)}s`;
      return;
    }

    contactSubmit.disabled = false;
    contactSubmit.textContent = contactSubmitLabel;

    if (contactCountdownTimer) {
      window.clearInterval(contactCountdownTimer);
      contactCountdownTimer = 0;
    }
  };

  const hasSpamSignals = () => {
    const formText = Array.from(contactForm?.querySelectorAll("input, textarea") || [])
      .filter((field) => !field.matches("[data-contact-honeypot]"))
      .map((field) => field.value || "")
      .join(" ")
      .toLowerCase();
    const automotiveIntent = /\b(?:wheel|wheels|tyre|tyres|tire|tires|rim|rims|4x4|4wd|fitment|offset|pcd|vehicle|car|ute|truck|hilux|ranger|patrol|landcruiser|wrx|enkei|michelin|mickey|yokohama|maxxis|bf ?goodrich|bfgoodrich|cooper|pirelli|bridgestone)\b/i.test(formText);
    const suspiciousPatterns = [
      /\bshopify\b/i,
      /\be-?commerce\b/i,
      /\bseo\b/i,
      /\bbacklinks?\b/i,
      /\bguest post\b/i,
      /\bconversion\b/i,
      /\bmarketing\b/i,
      /\bstore owner\b/i,
      /\bstore manager\b/i,
      /\byour site\b/i,
      /\bwebsite\b/i,
      /\blive yet\b/i,
      /\bsetup stage\b/i,
      /\bin charge\b/i,
      /\bconversation\b/i,
      /\bonetengarage\b/i,
      /\bcasino\b/i,
      /\bcrypto\b/i,
      /\bloan\b/i,
      /\btelegram\b/i,
      /\bwhats?app\b/i
    ];
    const suspiciousCount = suspiciousPatterns.reduce((total, pattern) => total + (pattern.test(formText) ? 1 : 0), 0);
    const linkCount = (formText.match(/(?:https?:\/\/|www\.|\.com\b|\.net\b|\.org\b|\.io\b|\.co\b)/g) || []).length;
    const hasVeryShortGenericMessage = contactMessage.value.trim().length < 42 && /\b(?:hello|hi|good day|curiosity|urgent|question)\b/i.test(formText);

    return !automotiveIntent && (suspiciousCount >= 2 || linkCount >= 2 || (suspiciousCount >= 1 && hasVeryShortGenericMessage));
  };

  if (contactSubmit && minimumSubmitDelay) {
    updateContactSubmitReadiness();
    contactCountdownTimer = window.setInterval(updateContactSubmitReadiness, 250);
  }

  [...requiredFields, ...contactMethodFields].forEach((field) => {
    field.addEventListener("input", () => {
      setFieldInvalid(field, false);
      clearContactSpamStatus();

      if (contactMethodFields.some((methodField) => methodField.value.trim())) {
        contactMethodFields.forEach((methodField) => setFieldInvalid(methodField, false));

        if (contactMethodError) {
          contactMethodError.hidden = true;
        }
      }
    });
  });

  contactForm?.addEventListener("submit", (event) => {
    if (contactHoneypots.some((field) => field.value.trim())) {
      event.preventDefault();
      return;
    }

    if (remainingSubmitDelay() > 0) {
      event.preventDefault();
      updateContactSubmitReadiness();
      setContactSpamStatus("Please wait a few seconds before sending. This helps us block automated spam.", "notice");
      return;
    }

    if (hasSpamSignals()) {
      event.preventDefault();
      setContactSpamStatus("This message looks like automated website spam and was not sent. If this is a genuine wheel or tyre enquiry, please mention your vehicle, product or fitment details, or call us directly.");
      contactMessage.focus({ preventScroll: true });
      contactMessage.scrollIntoView({ behavior: "auto", block: "center" });
      return;
    }

    let firstInvalidField = null;

    requiredFields.forEach((field) => {
      const isInvalid = !field.value.trim();
      setFieldInvalid(field, isInvalid);

      if (isInvalid && !firstInvalidField) {
        firstInvalidField = field;
      }
    });

    const emailField = contactForm.querySelector("#ContactFormEmail");
    const hasContactMethod = contactMethodFields.some((field) => field.value.trim());
    const hasInvalidEmail = Boolean(emailField?.value.trim()) && !emailField.validity.valid;

    contactMethodFields.forEach((field) => {
      const isInvalid = !hasContactMethod || (field === emailField && hasInvalidEmail);
      setFieldInvalid(field, isInvalid);

      if (isInvalid && !firstInvalidField) {
        firstInvalidField = field;
      }
    });

    if (contactMethodError) {
      contactMethodError.hidden = hasContactMethod && !hasInvalidEmail;
      contactMethodError.textContent = hasInvalidEmail
        ? "Use a valid email address, or leave email blank and add your phone number."
        : "Add an email or phone number so we can reply.";
    }

    if (firstInvalidField) {
      event.preventDefault();
      firstInvalidField.focus({ preventScroll: true });
      firstInvalidField.scrollIntoView({ behavior: "auto", block: "center" });
      return;
    }

    if (contactSubmit) {
      contactSubmit.disabled = true;
      contactSubmit.textContent = "Sending...";
    }
  });
}
